
import { Vue, Component, Prop, Ref } from "vue-property-decorator";
import { SmartText } from "_components";
import Flickity, { Options } from "flickity";

import ArrowButtons from "./ArrowButtons.vue";
import WhatsComingCard from "./WhatsComingCard.vue";
import { HomePageWhatsComingType } from "../../types";

@Component({
  name: "HomeWhatsComing",
  components: { SmartText, ArrowButtons, WhatsComingCard },
})
export default class HomeWhatsComing extends Vue {
  @Prop() data!: HomePageWhatsComingType;
  @Ref() carouselRef: HTMLElement;

  rootClass = "c-home-whats-coming";
  private flkty: Flickity | null = null;

  get title() {
    return this.data.title;
  }

  get blocks() {
    return this.data.blocks.length > 0 ? this.data.blocks : [];
  }
  
  mounted() {
    this.initFlickity();
  }

  beforeDestroy() {
    this.destroyFlickity();
  }

  private initFlickity(): void {
    const carousel = this.carouselRef as HTMLElement;
    if (!carousel) return;

    const options: Options = {
      cellAlign: "left",
      wrapAround: true,
      pageDots: false,
      prevNextButtons: false,
    };

    this.flkty = new Flickity(carousel, options);
  }

  private destroyFlickity(): void {
    if (this.flkty) {
      this.flkty.destroy();
      this.flkty = null;
    }
  }

  handlePrev() {
    if (!this.flkty) return;
    this.flkty.previous();
  }

  handleNext() {
    if (!this.flkty) return;
    this.flkty.next();
  }
}
